/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.archiveInboxItem

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.archiveInboxItem.ArchiveInboxItemApi
import features.archiveInboxItem.models.ArchiveResponseModel
import features.archiveInboxItem.serializeArchiveInboxItemState
import features.archiveInboxItem.models.ArchiveRequest

import kotlinx.serialization.decodeFromString

/**
 * Archive an inbox item.  [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("ArchiveInboxItemApi")
class ArchiveInboxItemApiJs {

    /**
     * Archive an inbox item. 
     */


    
    fun archiveInboxItem(overrideHeaders: String?,
serializedArchiveRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = ArchiveInboxItemApi().archiveInboxItem(
            overrideHeaders = decodedOverrideHeaders,
                archiveRequest = Json.decodeFromString(
                    serializedArchiveRequest
                )
            ).toJsonResult<ArchiveResponseModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeArchiveInboxItemState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        ArchiveInboxItemApi().archiveInboxItemState.serializeArchiveInboxItemState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
